(() => {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '[data-wei-reveal]';

  const show = (element) => element.classList.add('is-visible');

  const observe = (scope = document) => {
    const elements = scope.querySelectorAll(selector);
    if (!elements.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      elements.forEach(show);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          show(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    elements.forEach((element, index) => {
      element.style.setProperty('--wei-reveal-order', Math.min(index % 4, 3));
      observer.observe(element);
    });
  };

  root.classList.add('wei-motion-ready');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observe(), { once: true });
  } else {
    observe();
  }

  document.addEventListener('shopify:section:load', (event) => observe(event.target));
})();
